module.exports = "<svg viewBox=\"0 0 32 32\" fill=\"black\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M28.33 8H21.66V5.33C21.66 4.59 21.06 4 20.33 4H12.33C11.59 4 11 4.6 11 5.33V8H4.33C3.59 8 3 8.6 3 9.33V26.66C3 27.4 3.6 27.99 4.33 27.99H28.33C29.07 27.99 29.66 27.39 29.66 26.66V9.33C29.66 8.59 29.06 8 28.33 8ZM13.66 6.67H18.99V8H13.66V6.67ZM14.21 24.01L7.85 17.65L9.26 16.24L14.21 21.19L23.4 12L24.81 13.41L14.2 24.02L14.21 24.01Z\"></path><rect x=\"6\" y=\"12\" width=\"21\" height=\"15\"></rect></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./src/assets/reprise-travail.svg
// module id = +0YN
// module chunks = 2